import { Entity } from 'src/app/core/data/schema/entity';

export class Profile extends Entity {

    static className = 'Profile';
    static controller = 'users';
    static idField = 'userId';

    userId: number;
    displayName: string;
    username: string;
    pendingUsername: string;
    password: string;
    firstName: string;
    lastName: string;
    country: string;
    province: string;
    orgRole: string;
    roles: string[] = [];

    public constructor(profile?: Partial<Profile>) {
        super(Profile.className, Profile.idField, Profile.controller);
        Object.assign(this, profile);
    }

    get isSuperAdmin() {
        return this.roles.includes('SuperAdmin');
    }
}
